import { useState } from "react";
import { hotList } from "../data";

const filters = ["全部", "隐私", "伦理", "下架", "争议", "法规", "观点"];

export default function HotList() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? hotList : hotList.filter((h) => h.tag === active);

  return (
    <section id="hot" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        {/* heading */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <p className="text-primary-600 font-semibold tracking-wide text-sm">TRENDING · 今日热议</p>
            <h2 className="mt-2 font-heading text-3xl md:text-4xl font-extrabold text-foreground-950">
              最新热议现场
            </h2>
            <p className="mt-2 text-foreground-600 max-w-xl">
              搭讪实拍争议的最新进展、路人隐私故事与平台动作，每周持续更新。
            </p>
          </div>

          {/* filter chips */}
          <div className="flex flex-wrap gap-2" role="tablist" aria-label="按议题筛选">
            {filters.map((f) => (
              <button
                key={f}
                role="tab"
                aria-selected={active === f}
                onClick={() => setActive(f)}
                className={`h-9 px-4 rounded-full text-sm transition whitespace-nowrap ${
                  active === f
                    ? "bg-primary-500 text-background-50 font-medium"
                    : "bg-background-100 border border-background-200 text-foreground-700 hover:bg-background-200"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        {/* list */}
        <div className="mt-8 space-y-3">
          {list.map((h, i) => (
            <article
              key={h.title}
              className="group flex flex-col md:flex-row md:items-center gap-4 md:gap-6 p-4 md:p-5 rounded-2xl bg-background-100 border border-background-200 hover:border-primary-300 hover:bg-background-100/90 transition"
            >
              <div className="flex items-center gap-4 md:gap-6 md:w-[60%]">
                <span className="font-heading text-4xl md:text-[42px] font-black text-background-300 group-hover:text-primary-400 transition leading-none">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-800 text-xs font-medium">
                      <i className="ri-price-tag-3-line"></i>
                      {h.tag}
                    </span>
                    <span
                      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-semibold ${
                        h.hot === "爆"
                          ? "bg-primary-500 text-background-50"
                          : "bg-accent-100 text-accent-800"
                      }`}
                    >
                      <i className="ri-fire-fill"></i>
                      {h.hot}
                    </span>
                  </div>
                  <h3 className="mt-2 font-heading text-lg md:text-xl font-bold text-foreground-950 leading-snug group-hover:text-primary-700 transition">
                    {h.title}
                  </h3>
                </div>
              </div>

              <p className="md:w-[30%] text-sm leading-6 text-foreground-600 hidden xl:block">{h.excerpt}</p>

              <div className="flex md:w-[10%] flex-row md:flex-col items-center md:items-end justify-between md:justify-center gap-2 shrink-0">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{h.meta}</span>
                <a
                  href="#reading"
                  className="inline-flex items-center gap-1 text-primary-600 text-sm font-medium hover:text-primary-700 whitespace-nowrap"
                  aria-label={`阅读：${h.title}`}
                >
                  阅读 <i className="ri-arrow-right-up-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}